import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import LastModifiedButton from './LastModifiedButton';
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
export const refresh = () => {
    queryClient.invalidateQueries(['ui-change-log']);
};
export default function (props) {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(LastModifiedButton, Object.assign({}, props))));
}
//# sourceMappingURL=LastModifiedButtonWrapper.js.map